export const Validators = {
    required: (value) => {
        if (!value) {
            return { valid: false, error: 'This field is required' }
        }
        return { valid: true, error: null }
    },
    validatePhone: (phone) => {
        if (!phone.length) {
            return { valid: false, error: 'This field is required.' }
        }

        if (!phone.match(/^[+][(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/gm)) {
            return { valid: false, error: 'Please, enter a valid international phone number.' }
        }

        return { valid: true, error: null }
    },
    validateEmail: (email) => {
        if (!email || !email.length) {
            return { valid: false, error: 'This field is required' }
        }
        if (!email.match(/\S+@\S+\.\S+/)) {
            return { valid: false, error: 'Please, enter a valid email.' }
        }
        return { valid: true, error: null }
    },
    validateDestination: (fromLocation, destination) => {
        if (!destination) {
            return { valid: false, error: 'This field is required' }
        }
        if (fromLocation && fromLocation.iata_code === destination.iata_code) {
            return { valid: false, error: 'Choose a different destination' }
        }
        return { valid: true, error: null }
    },
}



// WEBPACK FOOTER //
// ./src/pages/index/components/shared/use-cases/validators.js